export const GEOANALYTICS_VERSION = __GEOANALYTICS_VERSION__;
